import { Suspense, useEffect, useRef } from 'react'
import { Link, Outlet, useLocation } from 'react-router'

import { LanguageToggle } from '../components/LanguageToggle'
import { LogoMark, Wordmark } from '../components/Logo'
import { useI18n } from '../i18n/context'

export function Layout() {
  const { t } = useI18n()
  const { pathname } = useLocation()
  const main = useRef<HTMLElement>(null)
  const previous = useRef(pathname)
  useEffect(() => {
    if (previous.current === pathname) return
    previous.current = pathname
    main.current?.focus({ preventScroll: true })
    window.scrollTo?.({ top: 0, behavior: 'instant' })
  }, [pathname])
  // Buyers arriving from a share link should not be pushed toward the seller Studio.
  const showSignIn = pathname === '/'
  return (
    <div className="shell">
      <a className="skip-link" href="#main-content">{t('a11y.skip')}</a>
      <header className="topbar">
        <div className="topbar-inner">
          <Link to="/" className="brand" aria-label={t('app.name')}>
            <LogoMark />
            <Wordmark />
          </Link>
          <nav className="topbar-nav" aria-label={t('a11y.navigation')}>
            <LanguageToggle />
            {showSignIn && (
              <Link to="/studio" className="btn btn-pill-soft btn-sm">
                {t('nav.signIn')}
              </Link>
            )}
          </nav>
        </div>
      </header>
      <main className="content" id="main-content" ref={main} tabIndex={-1}>
        <Suspense
          fallback={
            <output className="loading">
              <span className="spinner" aria-hidden="true" />
              {t('a11y.loading')}
            </output>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
